import _regeneratorRuntime from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/helpers/asyncToGenerator';

var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import API from '~/api/api.js';
import isBtn from '~/components/button';
import modal from '~/components/modal.vue';
import moment from 'moment';
// import HotelDatePicker from 'vue-rangedate-picker'
import HotelDatePicker from '~/components/range/RangedatePicker';
var miniToastr = void 0;
var Datepicker = void 0;
if (process.browser) {
  miniToastr = require('mini-toastr');
  Datepicker = require('vuejs-datepicker');
}
var userData = void 0;
var reload = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(token, params) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            API.setToken(token);

            return _context.abrupt('return', API.remindProject(params));

          case 2:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function reload(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export default {
  middleware: ['auth'],
  mounted: function mounted() {
    miniToastr.init();
  },

  notifications: {
    showLoginError: {
      title: 'Error',
      message: 'Hello from nuxt.js',
      type: 'error'
    },
    showSuccess: {
      title: 'Success',
      message: '',
      type: 'success'
    }
  },
  asyncData: function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
      var store = _ref2.store,
          params = _ref2.params,
          redirect = _ref2.redirect,
          error = _ref2.error;
      var response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              userData = store.state.authUser;
              _context2.next = 3;
              return reload(userData.tokenID, null);

            case 3:
              response = _context2.sent;

              if (!(response == null || response.status !== 200)) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt('return', error({ message: response.message, statusCode: response.status }));

            case 6:
              return _context2.abrupt('return', {
                send: {
                  projectID: '',
                  message: ''
                },
                result: response.data.datas,
                userData: userData,
                openRemind: false
              });

            case 7:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function asyncData(_x3) {
      return _ref3.apply(this, arguments);
    }

    return asyncData;
  }(),
  data: function data() {
    return {
      initRange: {
        start: '2018-02-05',
        end: '2018-02-10'
      },
      dateSend: {
        start: '',
        end: ''
      },
      captions: {
        title: 'Choose Dates',
        ok_button: 'Apply'
      },
      i18n: 'EN',
      shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      startDate: '',
      endDate: ''
      // i18n: {
      //   night: 'Night',
      //   nights: 'Nights',
      //   'day-names': ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'],
      //   'check-in': 'Check-in',
      //   'check-out': 'Check-Out',
      //   'month-names': [
      //     'January',
      //     'February',
      //     'March',
      //     'April',
      //     'May',
      //     'June',
      //     'July',
      //     'August',
      //     'September',
      //     'October',
      //     'November',
      //     'December'
      //   ]
      // }
    };
  },

  methods: {
    onDateSelected: function onDateSelected(daterange) {
      // this.selectedDate = daterange
      var startDate = daterange.start;
      var endDate = daterange.end;
      var format = 'YYYY-MM-DD';
      var start = moment(startDate).add(-1, 'days').format(format);
      var end = moment(endDate).add(-1, 'days').format(format);
      this.dateSend.start = start;
      this.dateSend.end = end;
    },
    Submit: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.reloadData();

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function Submit() {
        return _ref4.apply(this, arguments);
      }

      return Submit;
    }(),
    sendRemind: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.loadRemind(this.send);

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function sendRemind() {
        return _ref5.apply(this, arguments);
      }

      return sendRemind;
    }(),
    loadRemind: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(params) {
        var result;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                API.setToken(this.userData.tokenID);
                _context5.next = 3;
                return API.sendRemindProject(this.send);

              case 3:
                result = _context5.sent;

                if (result.data.flag) {
                  this.showSuccess({
                    message: result.data.message
                  });
                  this.$refs.btnSend.enabled();
                  this.openRemind = false;
                } else {
                  this.showLoginError({
                    message: result.data.message
                  });
                }

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function loadRemind(_x4) {
        return _ref6.apply(this, arguments);
      }

      return loadRemind;
    }(),
    openModal: function openModal(projectID) {
      this.send.projectID = projectID;
      this.openRemind = true;
    },
    reloadData: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var value;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return reload(this.userData.tokenID, this.dateSend);

              case 2:
                value = _context6.sent;

                this.result = value.data.datas;
                this.$refs.btn.enabled();

              case 5:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function reloadData() {
        return _ref7.apply(this, arguments);
      }

      return reloadData;
    }()
  },
  components: {
    isBtn: isBtn,
    modal: modal,
    miniToastr: miniToastr,
    Datepicker: Datepicker,
    HotelDatePicker: HotelDatePicker
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/admin/remind/index.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/admin/remind/index.vue
// module chunks = 29